import styled from 'styled-components'
import { Layout, Radio } from 'antd'

import { Text } from '../Ant'

export const ContainerToodo = styled(Text)`
  margin: -4px 16px 0 0;
`

export const WrapFooter = styled(Layout.Footer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
`

export const WrapRadioGroup = styled(Radio.Group)`
  margin-top: 16px;
`
